import { render } from "./gameNotes.vue?vue&type=template&id=298e4cb6&scoped=true"
import script from "./gameNotes.vue?vue&type=script&lang=js"
export * from "./gameNotes.vue?vue&type=script&lang=js"

import "./gameNotes.vue?vue&type=style&index=0&id=298e4cb6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298e4cb6"]])

export default __exports__